import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  // Wrapper that positions the pill. On tablet & desktop the banner is inline
  // within the header row (the AppBar supplies the brand[200] background). On
  // mobile the banner is rendered in the page content below the OnStar banner,
  // centered on the (transparent) grey page background.
  bannerBackdrop: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    // Mobile: centered on the full-width content area.
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
      padding: `${theme.new.spacing.small} ${theme.new.spacing.medium}`,
    },
    // Tablet & desktop: banner sits inline on the left of the header row.
    [theme.breakpoints.up('md')]: {
      flex: '0 1 auto',
      width: 'auto',
      paddingInlineStart: theme.new.spacing.xl,
    },
  },
  pill: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.new.spacing.medium,
    maxWidth: '100%',
    minHeight: '44px',
    padding: `${theme.new.spacing.xsmall} ${theme.new.spacing.medium}`,
    borderRadius: theme.new.shape.borderRadius.small,
    backgroundColor: theme.new.color.brand[100],
    border: `1px solid ${theme.new.color.brandPrimary}`,
    // Tablet: scaled-down fixed width that fits alongside the profile menu.
    [theme.breakpoints.up('md')]: {
      width: '450px',
    },
    // Desktop: full banner length.
    [theme.breakpoints.up('lg')]: {
      width: '650px',
    },
  },
  messageContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.new.spacing.small,
    minWidth: 0,
  },
  infoIcon: {
    flexShrink: 0,
    path: {
      stroke: theme.new.color.brandPrimary,
    },
  },
  exitContainer: {
    fontSize: `${theme.typography.small_body_medium.fontSize} !important`,
    flexShrink: 0,
    minWidth: 'auto',
    color: `${theme.new.color.textPrimary} !important`,

    '&:hover': {
      color: `${theme.new.color.textPrimary} !important`,
      textDecoration: 'underline',
    },
  },
}));

export default useStyles;
